module.exports = __webpack_public_path__ + "img/ComoFunciona-Banner-1080x200.2bef2529.jpg";